/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface ChildProviderDetail
 */
export interface ChildProviderDetail {
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof ChildProviderDetail
     */
    childProvider?: GuidIdAndLabel;
    /**
     * 
     * @type {string}
     * @memberof ChildProviderDetail
     */
    agencyName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChildProviderDetail
     */
    countryDialingCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChildProviderDetail
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChildProviderDetail
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChildProviderDetail
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChildProviderDetail
     */
    stateProvince?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChildProviderDetail
     */
    officeID?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChildProviderDetail
     */
    iataNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChildProviderDetail
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChildProviderDetail
     */
    country?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChildProviderDetail
     */
    postalCode?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChildProviderDetail
     */
    allowSalesTicketing?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChildProviderDetail
     */
    instantTicketing?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChildProviderDetail
     */
    isBSPPayment?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChildProviderDetail
     */
    channelId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChildProviderDetail
     */
    channelName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChildProviderDetail
     */
    flxUserName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChildProviderDetail
     */
    flxPassword?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChildProviderDetail
     */
    pcc?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChildProviderDetail
     */
    marketCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChildProviderDetail
     */
    marketName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChildProviderDetail
     */
    saleCity?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChildProviderDetail
     */
    currencyCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChildProviderDetail
     */
    accountCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChildProviderDetail
     */
    agentName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChildProviderDetail
     */
    agentPassword?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChildProviderDetail
     */
    agentRole?: string | null;
}

export function ChildProviderDetailFromJSON(json: any): ChildProviderDetail {
    return ChildProviderDetailFromJSONTyped(json, false);
}

export function ChildProviderDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChildProviderDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'childProvider': !exists(json, 'childProvider') ? undefined : GuidIdAndLabelFromJSON(json['childProvider']),
        'agencyName': !exists(json, 'agencyName') ? undefined : json['agencyName'],
        'countryDialingCode': !exists(json, 'countryDialingCode') ? undefined : json['countryDialingCode'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'stateProvince': !exists(json, 'stateProvince') ? undefined : json['stateProvince'],
        'officeID': !exists(json, 'officeID') ? undefined : json['officeID'],
        'iataNumber': !exists(json, 'iataNumber') ? undefined : json['iataNumber'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'postalCode': !exists(json, 'postalCode') ? undefined : json['postalCode'],
        'allowSalesTicketing': !exists(json, 'allowSalesTicketing') ? undefined : json['allowSalesTicketing'],
        'instantTicketing': !exists(json, 'instantTicketing') ? undefined : json['instantTicketing'],
        'isBSPPayment': !exists(json, 'isBSPPayment') ? undefined : json['isBSPPayment'],
        'channelId': !exists(json, 'channelId') ? undefined : json['channelId'],
        'channelName': !exists(json, 'channelName') ? undefined : json['channelName'],
        'flxUserName': !exists(json, 'flxUserName') ? undefined : json['flxUserName'],
        'flxPassword': !exists(json, 'flxPassword') ? undefined : json['flxPassword'],
        'pcc': !exists(json, 'pcc') ? undefined : json['pcc'],
        'marketCode': !exists(json, 'marketCode') ? undefined : json['marketCode'],
        'marketName': !exists(json, 'marketName') ? undefined : json['marketName'],
        'saleCity': !exists(json, 'saleCity') ? undefined : json['saleCity'],
        'currencyCode': !exists(json, 'currencyCode') ? undefined : json['currencyCode'],
        'accountCode': !exists(json, 'accountCode') ? undefined : json['accountCode'],
        'agentName': !exists(json, 'agentName') ? undefined : json['agentName'],
        'agentPassword': !exists(json, 'agentPassword') ? undefined : json['agentPassword'],
        'agentRole': !exists(json, 'agentRole') ? undefined : json['agentRole'],
    };
}

export function ChildProviderDetailToJSON(value?: ChildProviderDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'childProvider': GuidIdAndLabelToJSON(value.childProvider),
        'agencyName': value.agencyName,
        'countryDialingCode': value.countryDialingCode,
        'phoneNumber': value.phoneNumber,
        'email': value.email,
        'address': value.address,
        'stateProvince': value.stateProvince,
        'officeID': value.officeID,
        'iataNumber': value.iataNumber,
        'city': value.city,
        'country': value.country,
        'postalCode': value.postalCode,
        'allowSalesTicketing': value.allowSalesTicketing,
        'instantTicketing': value.instantTicketing,
        'isBSPPayment': value.isBSPPayment,
        'channelId': value.channelId,
        'channelName': value.channelName,
        'flxUserName': value.flxUserName,
        'flxPassword': value.flxPassword,
        'pcc': value.pcc,
        'marketCode': value.marketCode,
        'marketName': value.marketName,
        'saleCity': value.saleCity,
        'currencyCode': value.currencyCode,
        'accountCode': value.accountCode,
        'agentName': value.agentName,
        'agentPassword': value.agentPassword,
        'agentRole': value.agentRole,
    };
}


